import styled from "styled-components";

export const Container = styled.section`
  text-align: center;
  margin-top: 120px;
  padding-bottom: 110px;
  position: relative;
  color: black;
  .footer-row {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }
  .social-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    place-content: center flex-start;
    justify-content: center;
    gap: 5.8px;
    margin: 0 10px;
    /* .sm-card {
      padding: 16px;
      display: flex;
      text-align: center;
      justify-content: center; */
    /* width: 120px; */
    a {
      width: 49px;
      height: 49px;
      border-radius: 50%;
      background-color: rgb(0, 0, 0);
      display: flex;
      align-items: center;
      place-content: center;
      img {
        width: 75%;
        height: 75%;
      }
      /* p {
          font-size: 16px;
          line-height: 1.5;
          text-decoration: none;
        } */
      /* } */
    }
  }
  @media screen and (min-width: 968px) {
    .social-content {
      flex-wrap: nowrap;
    }
    .footer-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }
`;
